import React from 'react';

import PlansPage from "./PlanPage";

interface PlanPageProps {}

const PlanPageContainer: React.FC<PlanPageProps> = () => {
    return <PlansPage />
}

export default PlanPageContainer;